import { useEffect } from 'react';
import SEO from '../components/SEO';
import { TRACKING_API_URL } from '../config';

export default function SignUp() {
  useEffect(() => {
    // Track SignUp event
    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_name: 'SignUp',
      }),
    })
      .then(() => console.log('SignUp event tracked'))
      .catch((error) => console.error('Error tracking SignUp event:', error));

    // Redirect after 1 second
    const timer = setTimeout(() => {
      window.location.href = 'https://plataforma.lawx.ai/dashboard';
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Cadastro"
        description="Cadastre-se na LawX e comece a usar a melhor IA para advogados."
        url="/signup"
        noindex={true}
        nofollow={true}
      />
    </div>
  );
} 